export default __webpack_public_path__ + "static/media/image-17.8b0927ab.png";